<!---------------------------->
<!-- STEP: Address:-->
<!---------------------------->

<form [formGroup]="addressFormGroup">
  <mat-grid-list [rowHeight]="listFormRowHeight" cols="2">
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Type</mat-label>
        <mat-select [formControl]="addressType">
          <mat-option *ngFor="let type of addressTypes" [value]="type">
            {{type.name}}
          </mat-option>
        </mat-select>
      
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Type')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Address Line One</mat-label>
        <input [formControl]="addressLineOneFormControl" matInput type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Address Line 1')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
  
  </mat-grid-list>
  <mat-grid-list [rowHeight]="listFormRowHeight" cols="2">
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Country</mat-label>
        <mat-select [formControl]="countryFormControl">
          <mat-option *ngFor="let country of countries" [value]="country">
            {{country.name}}
          </mat-option>
        </mat-select>
      
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Country')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Address Line Two</mat-label>
        <input [formControl]="addressLine2FormControl" matInput type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Address Line 2')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list [rowHeight]="listFormRowHeight" cols="2">
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Province</mat-label>
        <input [formControl]="provinceFormControl" matInput type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Province')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Postal Code</mat-label>
        <input [formControl]="postalCodeFormControl" matInput type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Postal Code')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list [rowHeight]="listFormRowHeight" cols="2">
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>City-Town</mat-label>
        <input [formControl]="cityTownFormControl" matInput type="text">
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('City-Town')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>
    <mat-grid-tile>
      <div class="m-r-35 m-t-5">
        <app-element-checkbox
          [formControl]="doNotOverwriteAddress"
          label="Do Not Override">
        </app-element-checkbox>
      </div>
      <button (click)="addressSelected()" color="primary" mat-raised-button>Add Address</button>
    </mat-grid-tile>
  </mat-grid-list>
  <div class="align-center">
    <div *ngIf="!addressRequiredFieldsSelected" class="font-red">{{addressErrorMessage}}
    </div>
  </div>
  
  <mat-divider *ngIf="selectedAddresses.length > 0" style="margin-bottom: 16px;margin-top: 16px;"></mat-divider>
  <mat-error *ngIf="addressFormGroup.errors && addressFormGroup.errors.minimumAddresses"
             class="left-content claim-column-label">{{addressErrorMessage}}
  </mat-error>
  
  <div *ngIf="selectedAddresses && selectedAddresses.length > 0" class="left-content">
    <label class="column-label claim-column-label">Selected Addresses</label>
  </div>
  
  <div *ngFor="let addressElement of selectedAddresses" class="left-content reporting-list">
    
    <mat-icon (click)="removeAddress(addressElement)" class="table-icon" matTooltip="REMOVE Address">delete</mat-icon>
    &nbsp;
    <mat-icon (click)="editAddress(addressElement)" class="table-icon" matTooltip="EDIT ADDRESS">edit</mat-icon> &nbsp;
    <p>
      {{getAddressDisplayString(addressElement)}}
    </p>
    
    <div class="m-l-15">
      <app-element-checkbox [defaultValue]="(addressElement.address || addressElement.addressDTO)?.doNotOverwrite"
                            [disabled]="true"
                            label="Do Not Override"></app-element-checkbox>
    </div>
  </div>
  
  <div class="button-container">
    <button #addressBackButton color="primary" mat-raised-button matStepperPrevious>Back</button>
    <button (click)="resetAddressFormGroup()" color="warn" mat-raised-button>Clear</button>
    <button color="primary" mat-raised-button matStepperNext>Next</button>
  </div>
</form>